import React from 'react'

function Header() {
  return (
    <div className='box-1'>
    <h1>Barbaro Reyes</h1>
    </div>
  )
}

export default Header
